module.exports = __webpack_public_path__ + "img/icon-close.f96c5386.svg";